
import { createApi } from '@reduxjs/toolkit/query/react';

// import { API_URL } from '../../Constans/URL';
import customBaseQuery from '../baseQuery';
// const BASE_URL = API_URL;


const employeeGraphApi = createApi({
  reducerPath: 'employeeGraphApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getProfilePictureByEmployeeId: builder.query({
      query: ({ employeeId }: { employeeId: string }) => ({
        url: `employee-image/${employeeId}`,
        method: 'GET'
      }),
    }),
    getActiveEmployeesDetails: builder.query({
        query: () => ({
          url: "activeEmployeeMasters",
          method: 'GET'
        }),
      }),
      getActiveEmployeeDetailsByEmployeeId: builder.query({
        query: ({ employeeId }: { employeeId: string }) => ({
          url: `activeEmployeeDetailsByEmployeeId/${employeeId}`,
          method: 'GET'
        }),
      }),
  }),
});


export const { 
  useGetProfilePictureByEmployeeIdQuery,
  useGetActiveEmployeesDetailsQuery,
  useGetActiveEmployeeDetailsByEmployeeIdQuery
} = employeeGraphApi;


export default employeeGraphApi;
